import { render, staticRenderFns } from "./DialogApprovalPurchasePayment.vue?vue&type=template&id=0ec70115"
import script from "./DialogApprovalPurchasePayment.vue?vue&type=script&lang=js"
export * from "./DialogApprovalPurchasePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports